import * as angular from 'angular';
import * as moment from 'moment';

import { ComponentDefinition, LastProcessedDisplay } from '../../../models';
import { LastProcessedTimeline } from './lastProcessedTimeline.chart';
import { leftMargin } from './leftMargin';

class LastProcessedTimelineController implements angular.IComponentController {
    displayOnlyResults: boolean;
    isClickable: boolean;
    isLoading: boolean;
    lastProcessedDisplay: LastProcessedDisplay[];

    private _chart: LastProcessedTimeline;

    static $inject = [
        '$state',
        '$element'
    ];

    constructor(private _$state: angular.ui.IStateService,
        private _$element: angular.IAugmentedJQuery) {
    }

    $onInit() {
        const element = this._$element.find('.last-processed-timeline')[0];
        let plotMargins = null;
        if (this.displayOnlyResults) {
            plotMargins = {
                top: 0,
                bottom: 0,
                left: leftMargin,
                right: 0
            };
        }
        this._chart = new LastProcessedTimeline(element, plotMargins).data(this.lastProcessedDisplay);
        this._chart.callback = (d: LastProcessedDisplay) => {
            this._$state.go('timelineDetails', { beginDate: moment(d.beginDate).toISOString(), endDate: moment(d.endDate).toISOString() });
        };
        this._chart.render(this.isClickable, this.displayOnlyResults);
    }

    $onChanges(changesObj: angular.IOnChangesObject) {
        if (changesObj['lastProcessedDisplay'] && this._chart) {
            if (changesObj['lastProcessedDisplay'].currentValue) {
                this._chart.data(changesObj['lastProcessedDisplay'].currentValue)
                    .render(this.isClickable, this.displayOnlyResults);
            }
        }
    }
}

export const wtLastProcessedTimeline: ComponentDefinition = {
    componentId: 'wtLastProcessedTimeline',
    controller: LastProcessedTimelineController,
    template: require('./lastProcessedTimeline.component.html'),
    controllerAs: 'vm',
    bindings: {
        lastProcessedDisplay: '<',
        isLoading: '<?',
        timelineId: '@?',
        isClickable: '@?',
        displayOnlyResults: '@?'
    }
};
